export enum AB_TESTS {
  EXAMPLE = 'abtest_example',
  QUESTS = 'abtest_le_quests',
  PROGRESSIVE_OFFER = 'abtest_le_progressive',
}

export const AB_TESTS_PREFIX = 'abtest';

export const AB_TESTS_START_DATE: Partial<Record<AB_TESTS, string>> = {
  [AB_TESTS.QUESTS]: '2026-02-25 00:00:00 UTC',
  [AB_TESTS.PROGRESSIVE_OFFER]: '2026-03-23 00:00:00 UTC',
};

export const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss [UTC]';
